const componentStyles = new String(".candidate-privacy-notice.jsx-2c91bfefed8f2be6{margin-top:60px}");
componentStyles.__hash = "2c91bfefed8f2be6";
export default componentStyles;
